export default "__VITE_ASSET__Bhkltx2P__"